import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=2a29e44a&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=2a29e44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29e44a",
  null
  
)

export default component.exports